const PdfObject = ({ url, ...rest }) => {
  return (
    <object data={`${url}#view=Fit&pagemode=none`} type="application/pdf" {...rest}>
      <p>
        This browser does not support PDFs. Please download the PDF to view it: <a href={url}>Download PDF</a>.
      </p>
    </object>
  );
};

export default PdfObject;
